/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { createIndexTransform } from '../../factoriesAny.js';
export var indexTransformDependencies = {
  IndexDependencies: IndexDependencies,
  createIndexTransform: createIndexTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIndexTransform.generated.js
// module id = 1565
// module chunks = 0